// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a7d03854","453":"ae159826","455":"0fd9f087","977":"17738061"}[chunkId] + ".chunk.js";
};